import { useQuery } from "@tanstack/react-query";
import { agencySaleDetail } from "../../services/agencies-sales-details";
import { Total } from "../../services/agencies-sales-details/types";

export const AGENCIES_SALES_TOTAL_QUERY_KEY = "getAgenciesSalesDetailsTotal";

// Total vendido pela revenda numa janela [dateTimeInitial, dateTimeFinal].
// O backend escopa por conta própria (agency_id = ctx.userId). Usado no
// fechamento da aba Venda (total do dia + filtro de hora).
export const useGetAgenciesSalesTotal = (
  params: Total.Input = {},
  enabled = true
) => {
  const { data, isLoading, isFetching, refetch } = useQuery({
    queryKey: [AGENCIES_SALES_TOTAL_QUERY_KEY, params],
    enabled,
    queryFn: () => agencySaleDetail.getTotal(params),
  });

  return {
    total: data?.data?.total ?? 0,
    count: data?.data?.count ?? 0,
    isLoading,
    isFetching,
    refetch,
  };
};
